import React from 'react';
import { COLOR_COLUMNS, GREY_SWATCHES } from './colorPalette';

const SIZE = 24;
const GAP = 5;

const swatchStyle = (hex, selected) => ({
    width: SIZE,
    height: SIZE,
    borderRadius: '50%',
    backgroundColor: hex,
    border: selected
        ? '2px solid #ecff19'
        : hex === '#ffffff' ? '1px solid #444' : '2px solid transparent',
    outline: selected ? '1px solid #555' : 'none',
    boxSizing: 'border-box',
    cursor: 'pointer',
    flexShrink: 0,
    transition: 'border-color 0.12s',
});

/**
 * ColorChart – athletic palette (hue columns + greyscale row + custom picker).
 *
 * Props:
 *   selectedColor – active hex
 *   onSelect      – (hex) => void
 */
export default function ColorChart({ selectedColor, onSelect }) {
    const selected = (selectedColor || '').toLowerCase();

    return (
        <div>
            <div style={{ display: 'flex', gap: GAP, marginBottom: GAP + 4 }}>
                {COLOR_COLUMNS.map((col, ci) => (
                    <div key={ci} style={{ display: 'flex', flexDirection: 'column', gap: GAP }}>
                        {col.map((s) => (
                            <div
                                key={s.hex}
                                style={swatchStyle(s.hex, selected === s.hex)}
                                title={s.name}
                                onClick={() => onSelect(s.hex)}
                            />
                        ))}
                    </div>
                ))}
            </div>

            <div style={{ borderTop: '1px solid #2a2a2a', margin: '6px 0' }} />

            <div style={{ display: 'flex', gap: GAP, flexWrap: 'wrap' }}>
                {GREY_SWATCHES.map((s) => (
                    <div
                        key={s.hex}
                        style={swatchStyle(s.hex, selected === s.hex)}
                        title={s.name}
                        onClick={() => onSelect(s.hex)}
                    />
                ))}
                <input
                    type="color"
                    value={selected || '#ffffff'}
                    title="Custom colour"
                    onChange={(e) => onSelect(e.target.value)}
                    style={{
                        width: SIZE,
                        height: SIZE,
                        borderRadius: '50%',
                        border: '1px solid #444',
                        padding: 0,
                        cursor: 'pointer',
                        background: 'none',
                        boxSizing: 'border-box',
                        flexShrink: 0,
                    }}
                />
            </div>
        </div>
    );
}
